import Header from "../components/Authentication/Header";
import SignIn from "../components/Authentication/SignIn";

const SignInPage = () => {
  return (
    <>
      <Header title="Sign in to your account" />
      <SignIn />
    </>
  );
};

export default SignInPage;
